export enum EntityTypeEnum {
    Escola = 1,
    Campo = 2,
    Uniao = 3,
    Editora = 4,
    Divisao = 5
}
